import { render, staticRenderFns } from "./importEntity.vue?vue&type=template&id=4f18f5f8&scoped=true"
import script from "./importEntity.vue?vue&type=script&lang=js"
export * from "./importEntity.vue?vue&type=script&lang=js"
import style0 from "./importEntity.vue?vue&type=style&index=0&id=4f18f5f8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18f5f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f18f5f8')) {
      api.createRecord('4f18f5f8', component.options)
    } else {
      api.reload('4f18f5f8', component.options)
    }
    module.hot.accept("./importEntity.vue?vue&type=template&id=4f18f5f8&scoped=true", function () {
      api.rerender('4f18f5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/general-edit/importEntity.vue"
export default component.exports